/**
 * The addresses of the sections of Inställningar that a notice about the account leads to.
 *
 * Until build round 4 (2026-09-27) this file also held the overview's own mapping from a notification
 * to the place it is answered, because the overview's "Behöver er uppmärksamhet" was built from
 * unread notices. It is built from requests now, and only from the ones waiting for the client
 * (plan.md section 5.1, 2026-09-26: "Nothing else"), so the mapping went. The constants stay because
 * Notiser leads its security rows to the same sections (`app/routes/clientOps/notificationDestination.ts`).
 *
 * The sections are addresses since 2026-09-24, when the second build round split the one long settings
 * page into sections (`/settings/:section`).
 */

export const SETTINGS_SESSIONS = "/settings/sessions";
export const SETTINGS_MANAGEMENT = "/settings/management";
/** Namn och inloggning holds the sign-in address, Lösenord och tvåfaktor the password. */
export const SETTINGS_ACCOUNT = "/settings/account";
export const SETTINGS_SECURITY = "/settings/security";
